const singleCaseContextDefaultValue = {
  thisCase: {
    csid: undefined,
    participants: [],
    ready: false,
    pending: false,
    refreshPending: true,
    caseAutoJoin: false,
    ensureJoined: () => (null),
    handle: () => (null),
    hold: () => (null),
    resume: () => (null),
    close: () => (null),
    addParticipants: () => (null),
    requalify: () => (null),
    reject: () => (null),
    blockUser: () => (null),
    canBlockUser: false,
    leave: () => (null),
    toggleVideo: () => (null),
    clearEmergency: () => (null),
    commandPending: false,
    allGatherings: {
      // All available
      ready: false,
      list: null,
      selectedGthrId: undefined,
      selectedPublic: false,
      select: () => (null),
      setSelectedPublic: () => (null),
      create: () => (null),
    },
  },
};

export default singleCaseContextDefaultValue;
